<template>
    <div>
        <div class="row mb-n3">
            <div class="col-md-6 col-lg-4 mb-3">
                <div class="form-group mb-0">
                    <label for="departments">Départements</label>
                    <DepartmentSelect
                        id="departments"
                        v-model="value.departments"
                        @change="handleChanged"
                    />
                </div>
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
                <div class="form-group mb-0">
                    <label for="type">Type</label>
                    <select id="type" class="custom-select" v-model="value.category" @change="handleChanged">
                        <option :value="null">Sélectionnez un type...</option>
                        <template v-for="(name, value) in criterias.category">
                            <option :value="value">{{ name }}</option>
                        </template>
                    </select>
                </div>
            </div>
            <template v-if="showJobContractType">
                <div class="col-md-6 col-lg-4 mb-3">
                    <div class="form-group mb-0">
                        <label for="category">Type de contrat</label>
                        <select id="category" class="custom-select" v-model="value.job_contract_type" @change="handleChanged">
                            <option :value="null">Sélectionnez un type de contrat...</option>
                            <template v-for="(name, value) in criterias.job_contract_type">
                                <option :value="value">{{ name }}</option>
                            </template>
                        </select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import DepartmentSelect from "../search/criterias/geo/DepartmentSelect.vue";

    export default {
        components: {
            DepartmentSelect
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            showJobContractType() {
                return this.value.category === 'JOB'
            },
        },
        methods: {
            handleChanged() {
                if(this.value.category !== 'JOB') {
                    this.value.job_contract_type = null;
                }
                this.$emit('input', {
                    ...this.value,
                });
            },
        }
    }
</script>
